import React, { memo, useEffect, useState } from "react";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import stylesPc from "./ContentIndex.module.css";
import stylesSp from "./ContentIndex_SP.module.css";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import { filterVideoList } from "../../../common/video/VideoActions";
import FeaturedContentCard from "./featuredContentCard/FeaturedVideoCard";
import ContentList from "./contentList/ContentList";
import { Button, CircularProgress, createStyles, makeStyles, Theme } from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { resetfilter } from "../../../common/video/VideoFilterActions";
import ProjectIcon from "@material-ui/icons/Work";
import FilterWiget from "../../../common/components/filterWiget/FilterWiget";
import { changeMenu } from "../../../root/components/layout/header/HeaderActions";
import { GetAllProgram } from "../../../stores/program/ProgramActions";
import { filterUserList } from "../../../presenters/PresentersActions";
// import {GetAllProjectList} from "../../../store/actions/ExProjectActions";
import PuiTypography from "../../../components/elements/PuiTypography";
import PuiMessage from "../../../components/widgets/PuiMessage";
import { useInitFlag } from "../../../components/function/useInitFlag";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        pTag: {
            marginTop: "18px",
            marginRight: "20px",
            marginBottom: "8px",
            borderRadius: "0.7em",
            height: "48px",
            border: "none",
            fontSize: "21px",
            textTransform: "none",
        },
        tag: {
            marginTop: "20px",
            marginLeft: "15px",
            height: "24px",
            borderRadius: "13px",
            border: "1px solid #FFFFFF80",
            backgroundColor: "transparent",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "transparent",
            },
        },
        delIcon: {
            marginLeft: theme.spacing(1),
            fontSize: "16px",
            color: "white",
            cursor: "pointer",
        },
        projectIcon: {
            marginRight: theme.spacing(1),
            marginLeft: theme.spacing(-1),
            width: "30px",
            height: "30px",
            color: "var(--red)",
        },
        msg: {
            marginTop: "65px",
        },
    })
);

interface CheckObject {
    [key: string]: boolean;
}

function ContentIndex() {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const classes = useStyles();
    const [checkedItems, setCheckedItems] = React.useState<CheckObject>({});
    const [isFiltered, setIsFiltered] = React.useState(false);
    const [msg, setMsg] = React.useState<string>("");
    // 編集中のフラグ
    const [isEditing, setIsEditing] = useInitFlag();
    // データ取得中フラグ
    const [isLoadingData, setIsLoadingData] = useInitFlag(true);
    // 初期化フラグ
    const [isInit, setIsInit] = useInitFlag(true);

    const { contents, isEditVideo, isContentLoading } = useSelector(({ video }: AppState) => video);
    const dispatch = useDispatch();

    const { header } = useSelector((state: AppState) => ({
        header: state.header,
    }));

    const { videoFilter, video, isEditSlide } = useSelector((state: AppState) => ({
        videoFilter: state.videoFilter.videoFilters,
        video: state.video.video,
        isEditSlide: state.slide.isEditSlide,
    }));

    const { users, userInfo } = useSelector((state: AppState) => ({
        users: state.presenters.index.filteredUsers,
        userInfo: state.user.userInfo,
    }));

    useEffect(() => {
        if (userInfo) {
            dispatch(filterVideoList(userInfo.id, videoFilter));
            // if(userInfo) dispatch(GetAllProjectList(userInfo.id));
            dispatch(filterUserList({ id: parseInt(userInfo.id), skill: [], tag: [] }));
        }

        for (const item of videoFilter.tag) {
            if (!checkedItems[item]) {
                setCheckedItems({
                    ...checkedItems,
                    [item]: true,
                });
            }
        }

        if (
            videoFilter.professional.length > 0 ||
            videoFilter.project.length > 0 ||
            videoFilter.tag.length > 0
        ) {
            setIsFiltered(true);
        } else {
            setIsFiltered(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo, checkedItems, videoFilter, video, isEditSlide]);

    // ビデオ編集後、ビデオ画面に遷移するため、タグのフィルターを初期化する
    useEffect(() => {
        if (isEditVideo === true) {
            setCheckedItems({});
        }
    }, [isEditVideo]);

    // TODO：プログラム管理と一致する？
    // プログラム一覧取得（受講中を含め）
    useEffect(() => {
        // TODO: get ALL
        if (userInfo) {
            dispatch(GetAllProgram(userInfo.id));
            setIsInit(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, userInfo]);

    const delfilter = (type: string, item: string) => {
        switch (type) {
            case "professional":
                {
                    const professionalFilter = {
                        ...videoFilter,
                        professional: videoFilter.professional.filter((i) => i !== item),
                    };
                    dispatch(resetfilter(professionalFilter));
                }
                break;
            case "project":
                {
                    const projectFilter = {
                        ...videoFilter,
                        project: videoFilter.project.filter((i) => i !== item),
                    };
                    dispatch(resetfilter(projectFilter));
                }
                break;
            case "tag":
                setCheckedItems({
                    ...checkedItems,
                    [item]: false,
                });
                {
                    const tagFilter = {
                        ...videoFilter,
                        tag: videoFilter.tag.filter((i) => i !== item),
                    };
                    dispatch(resetfilter(tagFilter));
                }
                break;
            default:
                console.log("undefined type:" + type);
        }

        dispatch(changeMenu(header.from, header.to, "same"));
    };

    //Videoフィルダー
    const changeProfessionalFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
        const modFilter = {
            ...videoFilter,
            professional: event.target.value === "" ? [] : [event.target.value],
        };

        dispatch(resetfilter(modFilter));
        dispatch(changeMenu(header.from, header.to, "same"));
    };

    const changeProjectFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
        const modFilter = {
            ...videoFilter,
            project: event.target.value === "" ? [] : [event.target.value],
        };

        dispatch(resetfilter(modFilter));
        dispatch(changeMenu(header.from, header.to, "same"));
    };

    const changeTagFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCheckedItems({
            ...checkedItems,
            [event.target.name]: event.target.checked,
        });

        if (!videoFilter.tag.includes(event.target.name) && event.target.checked) {
            videoFilter.tag.push(event.target.name);
        }

        if (videoFilter.tag.includes(event.target.name) && !event.target.checked) {
            videoFilter.tag = videoFilter.tag.filter((t) => t !== event.target.name);
        }
        dispatch(resetfilter(videoFilter));
        dispatch(changeMenu(header.from, header.to, "same"));
    };

    const closeMsg = () => {
        setMsg("");
    };

    // 編集中のフラグ設定
    useEffect(() => {
        if (isEditVideo || isEditSlide) {
            setIsEditing(true);
        }
        // eslint-disable-next-line
    }, [isEditVideo, isEditSlide]);

    // 編集完了
    useEffect(() => {
        if (!isContentLoading && isEditing && !isEditVideo && !isEditSlide) {
            setIsEditing(false);
        }
        // eslint-disable-next-line
    }, [isContentLoading, isEditVideo, isEditSlide]);

    const [contentType, setContentType] = useState<string>("video");
    const [currentContent, setCurrentContent] = React.useState<any>([]);
    useEffect(() => {
        updateCurrentContents(contentType);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contents]);

    const updateCurrentContents = (contentType: string) => {
        const videos = contents.filter((content) => !content.fileType);
        const slidestocks = contents.filter((content) => content.fileType);
        setCurrentContent(contentType === "video" ? videos : slidestocks);
    };

    const switchContents = (contentType: string) => {
        setContentType(contentType);
        updateCurrentContents(contentType);
    };

    // ローディング完了
    useEffect(() => {
        if (!isContentLoading && isLoadingData && !isInit) {
            setIsLoadingData(false);
        }
        // eslint-disable-next-line
    }, [isContentLoading]);

    if (isContentLoading || isEditing || isLoadingData) {
        return (
            <div className={styles.noContent}>
                <CircularProgress size={60} style={{ color: "var(--loading-bg)" }} />
            </div>
        );
    }

    const contentList = (
        <>
            <div>
                <div className={styles.buttonArea}>
                    <div
                        className={styles.btn}
                        style={{
                            marginLeft: "50px",
                            marginRight: "16px",
                            borderBottom:
                                contentType === "video" ? "solid 3px #CCCCCC" : "solid 3px #24282E",
                        }}
                    >
                        <div
                            onClick={() => switchContents("video")}
                            className={styles.button}
                            style={{
                                width: IsDevice("iphone") ? "114px" : "64px",
                                color: contentType === "video" ? "#CCCCCC" : "#9C9C9C",
                            }}
                        >
                            動画
                        </div>
                    </div>
                    <div
                        className={styles.btn}
                        style={{
                            borderBottom:
                                contentType === "slide" ? "solid 3px #CCCCCC" : "solid 3px #24282E",
                        }}
                    >
                        <div
                            onClick={() => switchContents("slide")}
                            className={styles.button}
                            style={{
                                width: IsDevice("iphone") ? "114px" : "72px",
                                color: contentType === "slide" ? "#CCCCCC" : "#9C9C9C",
                            }}
                        >
                            スライド
                        </div>
                    </div>
                </div>
                {currentContent && currentContent.length > 0 && (
                    <>
                        <FilterWiget
                            contents={currentContent}
                            videoFilter={videoFilter}
                            checkedItems={checkedItems}
                            changeProfessionalFilter={changeProfessionalFilter}
                            changeProjectFilter={changeProjectFilter}
                            changeTagFilter={changeTagFilter}
                            setCheckedItems={setCheckedItems}
                        />
                    </>
                )}
                <div className={isFiltered ? styles.filter : ""}>
                    <div className={styles.filterLeftArea}>
                        {videoFilter.tag.length > 0 && (
                            <div className={styles.tagAreaText}>
                                <PuiTypography size={14} color="white">
                                    選択したタグ
                                </PuiTypography>
                            </div>
                        )}
                        {videoFilter.tag.map((tag, index) => (
                            <Button
                                key={`${index}`}
                                size="small"
                                variant="contained"
                                className={classes.tag}
                            >
                                <PuiTypography size={14} color="white">
                                    {tag}
                                </PuiTypography>
                                <img
                                    src={require("../../../assets/image/close_tag.svg")}
                                    alt="tag"
                                    style={{
                                        height: "16px",
                                        position: "absolute",
                                        bottom: "14px",
                                        right: "-6px",
                                    }}
                                    onClick={() => delfilter("tag", tag)}
                                />
                            </Button>
                        ))}
                    </div>
                    <div className={styles.professional}>
                        {videoFilter.professional.map((professional, index) => (
                            <Button
                                key={`${index}`}
                                size="medium"
                                variant="outlined"
                                className={classes.pTag}
                            >
                                <img
                                    className={styles.filterProfile}
                                    src={
                                        users
                                            ? users.filter((user) => user.name === professional)[0]
                                                  ?.imageUrl
                                            : ""
                                    }
                                    style={{ marginRight: "10px" }}
                                    onError={(e) =>
                                        (e.currentTarget.src = require("../../../assets/image/noPresenterImage.svg"))
                                    }
                                    alt=""
                                />
                                <PuiTypography size={IsDevice("desktop") ? 16 : 14}>
                                    {professional}
                                </PuiTypography>
                                <img
                                    src={require("../../../assets/image/close_tag.svg")}
                                    alt="tag"
                                    style={{
                                        height: "16px",
                                        marginLeft: "13px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => delfilter("professional", professional)}
                                />
                            </Button>
                        ))}
                        {videoFilter.project.map((project, index) => (
                            <Button
                                key={`${index}`}
                                size="medium"
                                variant="outlined"
                                className={classes.pTag}
                            >
                                <ProjectIcon className={classes.projectIcon} />
                                <PuiTypography>{project}</PuiTypography>
                                <HighlightOffIcon
                                    color="action"
                                    className={classes.delIcon}
                                    onClick={() => delfilter("project", project)}
                                />
                            </Button>
                        ))}
                    </div>
                </div>
                {currentContent.length === 0 && !isContentLoading ? (
                    <div className={styles.noVideo}>ただいま視聴できるContentsがございません</div>
                ) : (
                    <div className={isFiltered ? styles.videoArea : ""}>
                        <div>
                            {currentContent && (
                                <FeaturedContentCard content={currentContent[0]} setMsg={setMsg} />
                            )}
                        </div>
                        <div className={styles.list}>
                            {currentContent && (
                                <ContentList contents={currentContent.slice(1)} setMsg={setMsg} />
                            )}
                        </div>
                    </div>
                )}
            </div>

            <PuiMessage
                open={msg !== ""}
                type="success"
                title="登録に成功しました"
                detail={[
                    <PuiTypography key={msg} color="black">
                        {msg}
                    </PuiTypography>,
                ]}
                duration={6000}
                onClose={closeMsg}
            />
        </>
    );

    return <div className={styles.root}>{contentList}</div>;
}

export default memo(ContentIndex);
